<div class="modal-header">
    <h4 class="modal-title">{{'SelectingEmployees' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">

    <div class="row" >
        <div class="col" style="font-size: larger;">
            <b>{{weeklyWorkShift.jobAndUnitInfo.fullDescription}}</b>&nbsp;<div style="font-size: x-large">{{weeklyWorkShift.startTime | myDateFormat:'LT'}}-{{weeklyWorkShift.endTime | myDateFormat:'LT'}}</div>
        </div>
    </div>

    <div class="row" >

        <table class="table-responsive table-horarius">
            <thead>
            <tr>
                <th><a class="naked" (click)="toggleSortByName()" [ngbTooltip]="'ClickToSort' | translate">{{"FullName" | translate}}</a></th>
                <ng-template [ngIf]="canSeeAmount()">
                    <th style="width: 8%"><a class="naked" (click)="toggleSortByWage()" [ngbTooltip]="'ClickToSort' | translate">{{'CurrentWage' | translate}}</a></th>
                </ng-template>
                <th style="width: 8%"><a class="naked" (click)="toggleSortBySeniority()" [ngbTooltip]="'ClickToSort' | translate">{{'SeniorityInDaysShort' | translate}}</a></th>
                <th style="width: 8%">{{'LevelShort' | translate}}</th>
                <ng-template [ngIf]="dayVisible[0]">
                    <th style="width: 10%">{{dayLabel[0] | translate}}</th>
                </ng-template>
                <ng-template [ngIf]="dayVisible[1]">
                    <th style="width: 10%">{{dayLabel[1] | translate}}</th>
                </ng-template>
                <ng-template [ngIf]="dayVisible[2]">
                    <th style="width: 10%">{{dayLabel[2] | translate}}</th>
                </ng-template>
                <ng-template [ngIf]="dayVisible[3]">
                    <th style="width: 10%">{{dayLabel[3] | translate}}</th>
                </ng-template>
                <ng-template [ngIf]="dayVisible[4]">
                    <th style="width: 10%">{{dayLabel[4] | translate}}</th>
                </ng-template>
                <ng-template [ngIf]="dayVisible[5]">
                    <th style="width: 10%">{{dayLabel[5] | translate}}</th>
                </ng-template>
                <ng-template [ngIf]="dayVisible[6]">
                    <th style="width: 10%">{{dayLabel[6] | translate}}</th>
                </ng-template>
            </tr>
            </thead>
            <tbody>

            <ng-template [ngIf]="weeklyWorkShift.planned">
                <tr>
                    <ng-template [ngIf]="canSeeAmount()">
                        <td colspan="4">{{'PlannedPostes' | translate}}</td>
                    </ng-template>
                    <ng-template [ngIf]="!canSeeAmount()">
                        <td colspan="3">{{'PlannedPostes' | translate}}</td>
                    </ng-template>
                    <ng-template [ngIf]="dayVisible[0]">
                        <td>{{nbEmployeePlanned[0]}}</td>
                    </ng-template>
                    <ng-template [ngIf]="dayVisible[1]">
                        <td>{{nbEmployeePlanned[1]}}</td>
                    </ng-template>
                    <ng-template [ngIf]="dayVisible[2]">
                        <td>{{nbEmployeePlanned[2]}}</td>
                    </ng-template>
                    <ng-template [ngIf]="dayVisible[3]">
                        <td>{{nbEmployeePlanned[3]}}</td>
                    </ng-template>
                    <ng-template [ngIf]="dayVisible[4]">
                        <td>{{nbEmployeePlanned[4]}}</td>
                    </ng-template>
                    <ng-template [ngIf]="dayVisible[5]">
                        <td>{{nbEmployeePlanned[5]}}</td>
                    </ng-template>
                    <ng-template [ngIf]="dayVisible[6]">
                        <td>{{nbEmployeePlanned[6]}}</td>
                    </ng-template>
                </tr>
            </ng-template>

            <tr style="white-space:nowrap;" *ngFor="let bean of employeeForSchedulings; let idx = index;">
                <td>{{bean.employee.fullName}}</td>

                <ng-template [ngIf]="canSeeAmount()">
                    <td>{{bean.wage | myRound:2 | displayCurrency}}</td>
                </ng-template>

                <td>{{bean.seniority}}</td>
                <td>{{bean.level}}</td>

                <td *ngFor="let tmp of visibleDays">
                    <ng-template #template>
                        <ng-template [ngIf]="hasDayUnavailability(tmp,bean.employee.id)">
                            <div class="emprez-orange-fiesta" style="white-space: normal;padding: 5px;">
                                {{'NotAvailable' | translate}}<br>
                                {{getDayUnavailability(tmp,bean.employee.id)}}
                            </div>
                        </ng-template>
                        <ng-template [ngIf]="!isAvailable(tmp,bean)">
                            <div style="color: orange; white-space: normal;padding: 5px;">
                                {{explainNotAvailable(tmp,bean)}}
                            </div>
                        </ng-template>
                    </ng-template>

                    <ng-template [ngIf]="hasDayUnavailability(tmp,bean.employee.id) || !isAvailable(tmp,bean)">
                        <div class="emprez-orange-fiesta" style="white-space: normal; display: inline;" placement="top" [ngbPopover]="template" triggers="mouseenter:mouseleave">
                            <i class="fa fa-exclamation-triangle"></i>
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="!hasDayUnavailability(tmp,bean.employee.id) && isAvailable(tmp,bean)">
                        <div class="emprez-vert-agrume" style="display: inline;">
                            <i class="fad fa-check-circle"></i>
                        </div>
                    </ng-template>
                    <input type="checkbox" [disabled]="!isAvailable(tmp,bean)" (change)="onSelectRow(tmp,bean)" [ngModel]="isSelectedRow(tmp,bean)">
                </td>
            </tr>

            <ng-template [ngIf]="!employeeForSchedulings || employeeForSchedulings.length==0">
                <tr>
                    <td></td>
                    <td colspan="3">{{'NoEmployeeFound' | translate}}</td>
                </tr>
            </ng-template>

            </tbody>
        </table>

    </div>

</div>

<div class="modal-footer">
    <alert></alert>
    <button type="button" class="btn-link" (click)="onMissingWorkshift()">{{'MissingWorkShift' | translate}}</button>
    <button type="button" class="btn btn-primary" (click)="onValidate()">{{'Validate' | translate}}</button>
    <button type="button" class="btn btn-secondary" (click)="onCancel()">{{'Cancel' | translate}}</button>
</div>